import { JobStatus } from 'src/app/shared/modals/job-follow-up/enums/job-status.enum';

export class JobProgressNotification<T = string> {
    public id: string;
    public jobId: string;
    public progressPercentage: number;
    public status: JobStatus;
    public message: string;
    public data: T;

    constructor(data: Partial<JobProgressNotification>) {
        Object.assign(this, data);
    }
}
